<template lang="pug">
  m-table(
    store-name="admininvoices"
    :query-filter="queryFilter"
    :headers="headers"
    :item-actions="actions"
  )
</template>

<script>
import MTable from '~/components/modules/tables/m-table'
import { invoiceStatuses } from '~/modules/billing/constants/common'

export default {
  name: 'BlockOrganizationInvoices',
  components: { MTable },
  props: {
    organizationId: {
      type: String,
      default: null
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Invoice number',
          value: 'number',
          sortable: false,
          filterable: false
        },
        {
          text: 'Organization',
          value: 'organization.name',
          sortable: false,
          filterable: false
        },
        {
          text: 'Edrpou',
          value: 'organization.edrpou',
          sortable: false,
          filterable: false
        },
        {
          text: 'Sum, ₴',
          valueFormatter: invoice => (invoice.sum / 100).toFixed(2),
          sortable: false,
          filterable: false
        },
        {
          text: 'Discount sum, ₴',
          valueFormatter: invoice => (invoice.discountSum / 100).toFixed(2),
          sortable: false,
          filterable: false
        },
        {
          text: 'Total sum, ₴',
          valueFormatter: invoice => (invoice.totalSum / 100).toFixed(2),
          sortable: false,
          filterable: false
        },
        {
          text: 'Status',
          value: 'status',
          component: 'e-status-chip',
          componentProps: {
            statuses: invoiceStatuses
          },
          sortable: false,
          filterable: false
        },
        {
          text: 'Date of invoice',
          valueFormatter: invoice =>
            this.$moment.parseZone(invoice.date).format('DD.MM.YYYY, HH:mm'),
          sortable: false,
          filterable: false
        },
        {
          text: 'Date of payment',
          valueFormatter: invoice =>
            invoice.payedAt
              ? this.$moment.parseZone(invoice.payedAt).format('DD.MM.YYYY, HH:mm')
              : '-',
          sortable: false,
          filterable: false
        },
        {
          text: 'Actions',
          align: 'center',
          value: 'actions',
          width: '120',
          sortable: false,
          filterable: false
        }
      ]
    },
    actions() {
      return [
        {
          name: 'download',
          text: 'Download',
          icon: 'arrow-download',
          call: invoice => this.downloadInvoice(invoice)
        }
      ]
    },
    queryFilter() {
      return {
        'organization.id': this.organizationId
      }
    }
  }
}
</script>

<style scoped lang="scss"></style>
